import { Popup } from "../ui/popups"
import styled from "styled-components"
import {CloseButton, PillButton} from "../ui/buttons"
import { NoScroll } from "../../styles/dashboard"
import {capitalFirstLetter} from "../../utils";
import {SmallHeading} from "../ui/elements";
import {announcements} from "../../constants/announcements";

const PlansPopup = ({ plansData, handleChangePlan, isActivePlan, setShowPlansPopup }) => {
    return (
        <Popup paddingBottom={40} paddingTop={40} bg={'#FFF'} width={400}>
            <NoScroll />
            <SmallHeading style={{ paddingBottom: "4px" }}>
                {announcements.availablePlans}
            </SmallHeading>
            <DaysButtons>
                {plansData.purchasedPlans.map((plan, i) => (
                    <PillButton
                        key={i}
                        isDisabled={!isActivePlan(plan.plan_name)}
                        onClick={() => {
                            handleChangePlan(plan)
                            setShowPlansPopup(false)
                        }}
                    >
                        {capitalFirstLetter(plan.plan_name)}
                    </PillButton>
                ))}
            </DaysButtons>
            <CloseBtn onClick={() => setShowPlansPopup(false)} />
        </Popup>
    )
}

export default PlansPopup

const CloseBtn = styled(CloseButton)`
    display: flex;
    position: absolute;
    top: 30px;
    right: 30px;
`
const DaysButtons = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;

    button {
        margin-top: 20px;
        transition: all 0s;
        min-height: 30px;
        text-wrap: wrap;
    }
`